function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

class LogoTrailElement extends HTMLElement {
  connectedCallback() {
    this._logos = shuffle([...this.querySelectorAll(".logo-trail-logos img")]);

    this._index = 0;
    this._lastX = null;
    this._lastY = null;

    this._observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        addEventListener("pointerdown", this);
        addEventListener("pointermove", this);
      } else {
        removeEventListener("pointerdown", this);
        removeEventListener("pointermove", this);
      }
    });
    this._observer.observe(this);
  }

  disconnectedCallback() {
    this._observer.disconnect();
    removeEventListener("pointerdown", this);
    removeEventListener("pointermove", this);
  }

  handleEvent(e) {
    if (e.type === "pointerdown" || e.type === "pointermove") {
      const rect = this.getBoundingClientRect();
      const { clientX, clientY } = e;

      if (clientX < rect.left || clientX > rect.right || clientY < rect.top || clientY > rect.bottom) return;

      const x = clientX - rect.x;
      const y = clientY - rect.y;

      if (this._lastX == null) this._lastX = x;
      if (this._lastY == null) this._lastY = y;

      const dx = x - this._lastX;
      const dy = y - this._lastY;
      const d = Math.sqrt(dx * dx + dy * dy);

      if (d > 100) {
        const logo = this._logos[this._index].cloneNode();

        logo.style.position = "absolute";
        logo.style.left = `${x}px`;
        logo.style.top = `${y}px`;
        logo.style.rotate = `${(Math.random() - 0.5) * 50}deg`;

        this.append(logo);

        logo.animate(
          {
            opacity: [0, 1],
            transform: ["scale(1.5)", "scale(1)"],
            filter: ["blur(10px)", "blur(0)"],
          },
          { duration: 150, easing: "ease" },
        );

        setTimeout(() => {
          if (!this.isConnected) return;

          const anim = logo.animate(
            {
              opacity: [1, 0],
              transform: ["scale(1)", "scale(0.5)"],
              filter: ["blur(0)", "blur(2px)"],
            },
            { duration: 300, easing: "ease" },
          );

          anim.finished.then(() => {
            if (!this.isConnected) return;
            logo.remove();
          });
        }, 1000);

        this._lastX = x;
        this._lastY = y;
        this._index = (this._index + 1) % this._logos.length;
      }
    }
  }
}

customElements.define("logo-trail", LogoTrailElement);
